import { Calendar, Gauge, Fuel, Settings2 } from "lucide-react";
import { Link } from "react-router-dom";

const fmtPrice = (n) => n.toLocaleString("pt-PT") + " €";
const fmtKm = (n) => n.toLocaleString("pt-PT") + " km";

export default function VehicleCard({ vehicle: v, onEnquire }) {
  return (
    <article
      data-testid={`vehicle-card-${v.id}`}
      className="group bg-white border border-slate-200 hover:border-[#0072C6]/40 shadow-sm hover:shadow-lg transition-all duration-300 flex flex-col"
    >
      <div className="relative overflow-hidden">
        <img
          src={v.image_url}
          alt={v.title}
          loading="lazy"
          className="w-full h-52 object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {v.badge && (
          <span className="absolute top-3 left-3 bg-[#0072C6] text-white text-[11px] font-semibold tracking-wider uppercase px-3 py-1.5">
            {v.badge}
          </span>
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        {(v.brand || v.model) && (
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400 mb-1">
            {[v.brand, v.model].filter(Boolean).join(" · ")}
          </p>
        )}
        <h3 className="font-display text-xl text-[#0072C6]" data-testid={`vehicle-title-${v.id}`}>
          {v.title}
        </h3>
        <div className="mt-4 grid grid-cols-2 gap-y-2.5 text-xs text-slate-500">
          <span className="inline-flex items-center gap-1.5">
            <Calendar className="w-3.5 h-3.5 text-[#0072C6]" /> {v.year}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Gauge className="w-3.5 h-3.5 text-[#0072C6]" /> {fmtKm(v.km)}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Fuel className="w-3.5 h-3.5 text-[#0072C6]" /> {v.fuel}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Settings2 className="w-3.5 h-3.5 text-[#0072C6]" /> {v.transmission}
          </span>
        </div>
        <div className="mt-6 pt-5 border-t border-slate-100 flex items-center justify-between">
          <p className="font-display text-2xl text-slate-900" data-testid={`vehicle-price-${v.id}`}>
            {fmtPrice(v.price)}
          </p>
          <div className="flex items-center gap-2">
            <Link
              to={`/viaturas/${v.id}`}
              data-testid={`vehicle-view-${v.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-xs font-semibold tracking-wider uppercase text-[#0072C6] border border-[#0072C6] px-4 py-2.5 hover:bg-[#0072C6] hover:text-white transition-colors"
            >
              Ver
            </Link>
            <button
              data-testid={`vehicle-enquire-${v.id}`}
              onClick={(e) => { e.preventDefault(); onEnquire(v); }}
              className="text-xs font-semibold tracking-wider uppercase text-white bg-[#0072C6] px-4 py-2.5 hover:bg-[#005FA3] transition-colors"
            >
              Pedir Info
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}
